'use client'
import { useMemo } from 'react'
import { cn } from '@/utils/styles/cn'

type IGradientColor = 'from-white' | 'from-[#F4F4F4]' | 'from-neotaste' | 'from-neotaste-dark'

type IGradientDirection = 'to-right' | 'to-left' | 'to-top' | 'to-bottom'

interface IGradientProps {
    color?: IGradientColor
    className?: string
    direction?: IGradientDirection
}

export const Gradient = ({
    color = 'from-white',
    className,
    direction = 'to-left',
}: IGradientProps) => {
    const rotate = useMemo(() => {
        switch (direction) {
            case 'to-right':
                return 'rotate-180'
            case 'to-left':
                return ''
            case 'to-top':
                return 'rotate-90'
            case 'to-bottom':
                return 'rotate-270'
        }
    }, [direction])

    return (
        <div
            className={cn(
                'min-w-[56px] pointer-events-none min-h-[56px] bg-gradient-to-l z-[1]',
                color,
                rotate,
                className
            )}
        />
    )
}
